import { render, staticRenderFns } from "./orderDetailList.vue?vue&type=template&id=01991c18"
import script from "./orderDetailList.vue?vue&type=script&lang=js"
export * from "./orderDetailList.vue?vue&type=script&lang=js"
import style0 from "./orderDetailList.vue?vue&type=style&index=0&id=01991c18&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports